import OmCard from '../ui/OmCard';

const CriticalIllnessDetails = ({ claim }) => {
  // Check if diagnosis is cancer-related (same logic as form)
  const isCancerRelated = claim.diagnosis && 
    claim.diagnosis.toLowerCase().includes('cancer');

  return (
    <OmCard className="bg-crystal-white shadow-soft border border-steel/20 rounded-lg overflow-hidden transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:border-fresh-leaf/30 focus-within:ring-2 focus-within:ring-fresh-leaf/25 focus-within:border-fresh-leaf/40">
      <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 sm:pb-6 border-b border-steel/15">
        <h3 className="text-xl sm:text-2xl font-semibold text-graphite mb-3">Critical Illness Details</h3>
        <p className="text-sm sm:text-base text-steel">Information specific to this critical illness claim</p>
      </div>
      <div className="p-6 sm:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          <div className="space-y-3 group cursor-default">
            <label className="block text-xs sm:text-sm font-medium text-steel uppercase tracking-wider transition-colors duration-200 group-hover:text-forest-fern">Diagnosis</label>
            <p className="text-sm sm:text-base text-graphite font-medium transition-all duration-200 group-hover:text-deep-jungle group-hover:scale-[1.02] select-all">{claim.diagnosis || 'N/A'}</p>
          </div>
          <div className="space-y-3 group cursor-default">
            <label className="block text-xs sm:text-sm font-medium text-steel uppercase tracking-wider transition-colors duration-200 group-hover:text-forest-fern">Diagnosis Date</label>
            <p className="text-sm sm:text-base text-graphite font-medium transition-all duration-200 group-hover:text-deep-jungle group-hover:scale-[1.02]">
              {claim.diagnosisDate ? new Date(claim.diagnosisDate).toLocaleDateString() : 'N/A'}
            </p>
          </div>
          {/* Only show Illness Stage for cancer-related diagnoses */}
          {isCancerRelated && claim.illnessStage && (
            <div className="sm:col-span-2 space-y-3 group cursor-default">
              <label className="block text-xs sm:text-sm font-medium text-steel uppercase tracking-wider transition-colors duration-200 group-hover:text-forest-fern">Illness Stage</label>
              <p className="text-sm sm:text-base text-graphite font-medium transition-all duration-200 group-hover:text-deep-jungle group-hover:scale-[1.02] select-all">{claim.illnessStage}</p>
            </div>
          )}
        </div>
      </div>
    </OmCard>
  );
};

export default CriticalIllnessDetails;
